<template>
  <div>
    <p v-if="label !== ''" :class="['label', labelCenter ? 'labelCenter' : '']">
      <font color="red" v-if="required">*</font>{{ label }}
      <i class="el-icon-zoom-in" @click="showBigImg"></i>
    </p>
    <div class="content">
      <VueImgInputer
        v-model="result"
        theme="material"
        size="normal"
        :img-src="result"
        :max-size="picMaxSize"
        :readonly="readonly"
        v-loading="loading"
        @onChange="upload"
        :placeholder="placeholder"
        class="imgPad"
      ></VueImgInputer>
      <img v-if="exampleImg !== ''" :src="exampleImg" alt="" class="exampleImg"/>
    </div>
    <!--  图片放大弹窗    -->
    <el-dialog title="查看图片详情" :visible.sync="dialogBigImgVisible" width="800px" append-to-body>
      <img :src="result" alt="" class="bigImg">
    </el-dialog>
  </div>
</template>

<!--带示例的上传图片-->
<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { singleTransPic, uploadPic } from '@/api/global'
export default {
  name: 'UploadImg',
  components: {
    VueImgInputer
  },
  props: {
    // 是否只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 文件大小上限
    picMaxSize: {
      type: Number,
      default: 1024 * 3
    },
    placeholder: {
      type: String,
      default: '请上传图片'
    },
    value: {
      type: String,
      default: ''
    },
    // 结果存储属性名
    valueName: {
      type: String,
      default: ''
    },
    // 示例图片路径
    exampleImg: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    // label是否居中
    labelCenter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      result: '', // 结果值
      loading: false,
      dialogBigImgVisible: false
    }
  },
  watch: {
    value (val, oldVal) {
      if (this.result === '') {
        if (this.value.indexOf('http://') >= 0) {
          this.result = val
        } else {
          const param = qs.stringify({ path: val })
          singleTransPic(param).then(response => {
            if (response.error_code === '0') {
              this.result = response.data.show_path
            }
          })
        }
      }
    }
  },
  mounted () {
    if (this.value && this.result === '') {
      const that = this
      if (this.value.indexOf('http://') >= 0) {
        this.result = this.value
      } else {
        const param = qs.stringify({ path: that.value })
        singleTransPic(param).then(response => {
          if (response.error_code === '0') {
            this.result = response.data.show_path
          }
        })
      }
    }
  },
  methods: {
    upload () {
      var that = this
      var reader = new FileReader()
      this.loading = true
      reader.readAsDataURL(this.result)
      reader.onload = function (e) {
        var file = this.result
        file = file.split('base64,')
        var data = {
          // merchantId : merchantId,
          base64pic: file[1],
          picType: that.resultName
        }
        data = qs.stringify(data)
        uploadPic(data).then(data => {
          that.loading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.result = data.showPath
            data.valueName = that.valueName
            that.$emit('success', data)
          } else {
            that.$message({
              message: data.error_msg,
              type: 'error'
            })
            that.$emit('failed', data)
          }
        }).catch(err => {
          console.log(err)
          that.loading = false
          that.$emit('failed', data)
          that.$message({
            showClose: true,
            message: '图片过大，请压缩后上传！',
            type: 'error'
          })
        })
      }
    },
    // 图片放大
    showBigImg () {
      if (this.result) {
        this.dialogBigImgVisible = true
      } else {
        this.$message({
          message: '请先上传图片',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
    .imgPad{
        margin-left: 10px;
        margin-bottom: 10px;
    }
    .content{
        display: flex;
        align-items: flex-start;
    }
    .exampleImg{
        width: 160px;
        height: 92px;
        margin-left: 15px;
    }
    img.bigImg {
        max-width: 100%;
        display: block;
    }
    .label{
        margin: 0;
    }
    .labelCenter{
        text-align: center;
    }
    .label i{
        margin-left: 10px;
        cursor: pointer;
    }
    .img-inputer__preview-box{
        display: flex;
        display: -webkit-flex;
        display: -ms-flex;
        align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }
</style>
